import React from 'react';
import { CheckIcon } from 'lucide-react';
import { howWeWorkItems } from '../data/content';
import { Reveal } from './showcase/Reveal';
export function HowWeWork() {
  return <section id="how-we-work" aria-labelledby="how-we-work-title" className="border-b border-white/5 bg-ink-900" data-id="element-131" data-mp="3uh1cmzczh6z7">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 sm:py-20" data-id="element-132" data-mp="39owmnnu6zkv">
        <Reveal data-id="element-133" data-mp="3lftsdl7ay6o4">
          <h2 id="how-we-work-title" className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-134" data-mp="3lg3gf38se3r6">
            How we work.
          </h2>
        </Reveal>

        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-135" data-mp="3bjqg3miqkrng">
          {howWeWorkItems.map((item, index) => <li key={item} className="h-full" data-id="element-136" data-mp="3gj3dh178hh4a" data-mpi={index}>
              <Reveal delay={0.06 * index} className="h-full" data-id="element-137" data-mp="19qiyg6fnhxye">
                <div className="flex h-full items-start gap-3 rounded-xl border border-white/10 bg-ink-800 p-6 text-sm font-medium text-white/80" data-id="element-138" data-mp="1epvm2tecj921">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-139" data-mp="2djpyssbnelt3" />
                  <span className="leading-relaxed" data-id="element-140" data-mp="2md30ains2vqs">{item}</span>
                </div>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}